import { render, staticRenderFns } from "./PoiIconHelp.vue?vue&type=template&id=dec21a68&scoped=true&"
import script from "./PoiIconHelp.vue?vue&type=script&lang=js&"
export * from "./PoiIconHelp.vue?vue&type=script&lang=js&"
import style0 from "./PoiIconHelp.vue?vue&type=style&index=0&id=dec21a68&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec21a68",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
